import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { BrandName } from "../components/BrandName";
import { ProductBrowser } from "../components/ProductBrowser";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BrandPage() {
  const { slug } = useParams();
  const [brand, setBrand] = useState(undefined);

  useEffect(() => {
    axios.get(`${API}/brands`).then((r) => setBrand(r.data.find((b) => b.slug === slug) || null)).catch(() => setBrand(null));
  }, [slug]);

  return (
    <div className="App grain bg-offwhite min-h-screen" data-testid="brand-page">
      <Navbar />
      <main className="w-full max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 pt-32 md:pt-40 pb-24">
        {brand === undefined ? (
          <p className="text-military-dark/50 text-sm py-20 text-center">Carregando...</p>
        ) : brand === null ? (
          <div className="py-20 text-center">
            <p className="font-serif text-3xl text-military-dark mb-4">Marca não encontrada.</p>
            <Link to="/marcas" data-testid="brand-back-link" className="text-xs uppercase tracking-widest font-semibold text-military underline underline-offset-4">Ver todas as marcas</Link>
          </div>
        ) : (
          <>
            <header className="mb-12">
              <p className="text-xs uppercase tracking-[0.3em] text-military font-semibold mb-4">
                <Link to="/marcas" className="hover:text-military-dark transition-colors">Marcas</Link>
              </p>
              <h1 className="font-serif text-4xl md:text-6xl text-military-dark tracking-tight" data-testid="brand-name"><BrandName name={brand.name} /><span className="italic font-light text-military">.</span></h1>
              <p className="text-sm text-military-dark/50 mt-4">{brand.product_count} produto(s) desta marca</p>
            </header>
            <ProductBrowser fixedBrand={brand.name} />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
